import Vue from 'vue';
import App from './App.vue';
import store from './store';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;

// Read package data from Django template
const packageElement = document.getElementById('__package__');
let packageData = {};

if (!packageElement) {
  // eslint-disable-next-line no-console
  console.warn('[Handshake] Package data element not found, phone exceptions disabled');
} else {
  try {
    packageData = JSON.parse(packageElement.textContent);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[Handshake] Failed to parse package data:', e);
  }
}

// Make phone exception area codes available globally
Vue.prototype.$phoneExceptionAreaCodes = packageData.phoneExceptionAreaCodes || [];

new Vue({
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
